/**
 * @generated SignedSource<<aa5124d3c11e9f5c3e585391648f881b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetCalendarOverviewQuery$variables = {
  after?: string | null;
  first?: number | null;
  widgetId: string;
};
export type WidgetCalendarOverviewQuery$data = {
  readonly widgetCalendarOverview: {
    readonly calendars: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetCalendarOverviewContent_widget">;
  } | null;
};
export type WidgetCalendarOverviewQuery = {
  response: WidgetCalendarOverviewQuery$data;
  variables: WidgetCalendarOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "widgetId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "widgetId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "includeExternal",
      "value": false
    }
  ],
  "concreteType": "StoreCalendar",
  "kind": "LinkedField",
  "name": "calendars",
  "plural": true,
  "selections": (v5/*: any*/),
  "storageKey": "calendars(includeExternal:false)"
},
v7 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v9 = [
  (v8/*: any*/)
],
v10 = [
  (v8/*: any*/),
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "DEFAULT"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
  }
],
v11 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "WEEKDAY_AND_DATE"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"WEEKDAY_AND_DATE\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetCalendarOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "WidgetCalendarOverview",
        "kind": "LinkedField",
        "name": "widgetCalendarOverview",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WidgetCalendarOverviewContent_widget"
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WidgetCalendarOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "WidgetCalendarOverview",
        "kind": "LinkedField",
        "name": "widgetCalendarOverview",
        "plural": false,
        "selections": [
          {
            "alias": "connectedCalendars",
            "args": [
              {
                "kind": "Literal",
                "name": "includeExternal",
                "value": true
              }
            ],
            "concreteType": "StoreCalendar",
            "kind": "LinkedField",
            "name": "calendars",
            "plural": true,
            "selections": (v5/*: any*/),
            "storageKey": "calendars(includeExternal:true)"
          },
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "StoreCalendarTeamCalendarEventsConnection",
            "kind": "LinkedField",
            "name": "calendarEvents",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreCalendarTeamCalendarEventsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CalendarEvent",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "startAt",
                        "plural": false,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "endAt",
                        "plural": false,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "createdAt",
                        "plural": false,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAllDayEvent",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreCalendar",
                        "kind": "LinkedField",
                        "name": "storeCalendar",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "startAtDateAndTime",
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "startAt",
                        "plural": false,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "endAtDateAndTime",
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "endAt",
                        "plural": false,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "startAtWeekdayAndDate",
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "startAt",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "endAtWeekdayAndDate",
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "endAt",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "endAtTime",
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "endAt",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "style",
                                "value": "TIME_ONLY"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "storeFormattedDate",
                            "storageKey": "storeFormattedDate(style:\"TIME_ONLY\")"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__id",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v7/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "WidgetCalendarOverviewContent__calendarEvents",
            "kind": "LinkedHandle",
            "name": "calendarEvents"
          },
          (v4/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5aaf07a5a81197cc09f60a46d29dfa18",
    "id": null,
    "metadata": {},
    "name": "WidgetCalendarOverviewQuery",
    "operationKind": "query",
    "text": "query WidgetCalendarOverviewQuery(\n  $widgetId: ID!\n  $first: Int\n  $after: String\n) {\n  widgetCalendarOverview(id: $widgetId) {\n    ...WidgetCalendarOverviewContent_widget\n    calendars(includeExternal: false) {\n      id\n    }\n    id\n  }\n}\n\nfragment CalendarOverviewEventItemDateTime_event on CalendarEvent {\n  startAtDateAndTime: startAt {\n    isoString\n    ...StoreFormattedDate_2LP8ap\n  }\n  endAtDateAndTime: endAt {\n    isoString\n    ...StoreFormattedDate_2LP8ap\n  }\n  startAtWeekdayAndDate: startAt {\n    ...StoreFormattedDate_1hpjGt\n  }\n  endAtWeekdayAndDate: endAt {\n    ...StoreFormattedDate_1hpjGt\n  }\n  endAtTime: endAt {\n    ...StoreFormattedDate_1b2lNL\n  }\n  isAllDayEvent\n}\n\nfragment StoreFormattedDate_1b2lNL on StoreZonedDate {\n  storeFormattedDate(style: TIME_ONLY)\n}\n\nfragment StoreFormattedDate_1hpjGt on StoreZonedDate {\n  storeFormattedDate(style: WEEKDAY_AND_DATE)\n}\n\nfragment StoreFormattedDate_2LP8ap on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment WidgetCalendarOverviewContent_widget on WidgetCalendarOverview {\n  connectedCalendars: calendars(includeExternal: true) {\n    id\n  }\n  calendarEvents(first: $first, after: $after) {\n    edges {\n      node {\n        id\n        startAt {\n          isoString\n        }\n        endAt {\n          isoString\n        }\n        createdAt {\n          isoString\n        }\n        isAllDayEvent\n        ...WidgetCalendarOverviewEventItem_event\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment WidgetCalendarOverviewEventItem_event on CalendarEvent {\n  title\n  storeCalendar {\n    color\n    id\n  }\n  ...CalendarOverviewEventItemDateTime_event\n}\n"
  }
};
})();

(node as any).hash = "1350e6c93bae1c9200cb2bf5a084dfa7";

export default node;
